const API_URL = import.meta.env.VITE_API_URL;

const getAuthToken = () => localStorage.getItem('accessToken');

export const getAllFaqs = async () => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/faq`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Error al obtener FAQs');
  return response.json();
};

export const createFaq = async (data) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/faq`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al crear FAQ');
  return response.json();
};

export const updateFaq = async (id, data) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/faq/${id}`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al actualizar FAQ');
  return response.json();
};

export const deleteFaq = async (id) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/faq/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Error al eliminar FAQ');
  return response.json();
};

export const getAllCategories = async () => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/category`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Error al obtener categorías');
  return response.json();
};

export const createCategory = async (data) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/category`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al crear categoría');
  return response.json();
};

export const updateCategory = async (name, data) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/category/${encodeURIComponent(name)}`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) throw new Error('Error al actualizar categoría');
  return response.json();
};

export const renameCategory = async (oldName, newName) => {
  return updateCategory(oldName, { name: newName });
};

export const deleteCategory = async (name) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/category/${encodeURIComponent(name)}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Error al eliminar categoría');
  return response.json();
};

export const getRatingStats = async () => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/ratings/stats`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Error al obtener estadísticas de rating');
  return response.json();
};

export const getRatingsPaginated = async (page = 1, limit = 15) => {
  const token = getAuthToken();
  const response = await fetch(`${API_URL}/chatbot/ratings?page=${page}&limit=${limit}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) throw new Error('Error al obtener valoraciones');
  return response.json();
};
